import { graphql } from '@/graphql-setup'

export const CREATE_QUILL_MEDIA_MUTATION = graphql(`
  mutation CreateQuillMedia($input: CreateQuillMediaInput!) {
    createQuillMedia(input: $input) {
      quillMedia {
        id
        name
        file
      }
    }
  }
`)
